export default __webpack_public_path__ + "static/media/recipes_icon.1cdbaf11.svg";